import {memo} from 'react';

interface TDProps {
    last?: boolean,
    className?: string,
    children: JSX.Element | string | number
}
const TD = ({className, last, children}:TDProps) => {

    let extraClasses = last ? 'p-4' : 'p-4 border-b border-blue-gray-50 dark:border-blue-gray-800';
    if (!className?.includes('text-left') && !className?.includes('text-right') && !className?.includes('text-center'))
        extraClasses+=' text-center';

    return <td className={`${className?? ''} ${extraClasses}`}>{children}</td>
}

export default memo(TD);
